(function () {
  'use strict';

  var theme = window.theme || { strings: {}, routes: {} };

  /* Money ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    if (!format && theme.currency === 'RSD') format = '{{amount_no_decimals_with_comma_separator}} RSD';
    format = format || theme.moneyFormat || '{{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return 0;
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(cents, 0, ' ', ',');
        default: return withDelimiters(cents, 2, ',', '.');
      }
    });
  }

  /* Toast ------------------------------------------------------------------ */
  var toastTimer;
  function showToast(message, isError) {
    var toast = document.getElementById('Toast');
    if (!toast) return;
    toast.textContent = '';
    toast.classList.toggle('is-error', !!isError);
    var text = document.createElement('span');
    text.textContent = message;
    toast.appendChild(text);
    if (!isError) {
      var link = document.createElement('a');
      link.href = theme.routes.cart;
      link.textContent = theme.strings.viewCart;
      toast.appendChild(link);
    }
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4500);
  }

  /* Cart ------------------------------------------------------------------- */
  function updateCartCount() {
    return fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count === 0 ? theme.strings.cartEmpty : '(' + cart.item_count + ')';
        });
      });
  }

  function addToCart(form, button) {
    if (button) button.disabled = true;
    return fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || theme.strings.error);
        showToast(theme.strings.added);
        return updateCartCount();
      })
      .catch(function (err) { showToast(err.message || theme.strings.error, true); })
      .finally(function () { if (button && !button.hasAttribute('data-keep-disabled')) button.disabled = false; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('.js-ajax-add, [data-product-form]')) return;
    // "Buy now" buttons must go straight to checkout.
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  /* Quantity buttons ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    var val = parseInt(input.value || '0', 10) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-qty]')) {
      clearTimeout(e.target._t);
      var form = e.target.form;
      e.target._t = setTimeout(function () { form.submit(); }, 500);
    }
  });

  /* Mobile menu ------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    var open = !nav.classList.contains('is-open');
    nav.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
  });

  /* Slideshow -------------------------------------------------------------- */
  function initSlideshow(root) {
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    var index = 0;
    var timer;

    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === index);
        s.setAttribute('aria-hidden', String(n !== index));
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }
    function play() {
      if (root.dataset.autoplay !== 'true') return;
      clearInterval(timer);
      timer = setInterval(function () { go(index + 1); }, parseInt(root.dataset.speed, 10) || 6000);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); play(); });
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', function () { clearInterval(timer); });

    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); play(); }
      startX = null;
    });

    // Theme editor: show the selected slide.
    document.addEventListener('shopify:block:select', function (e) {
      var i = Array.prototype.indexOf.call(slides, e.target.closest('[data-slide]'));
      if (i > -1) { clearInterval(timer); go(i); }
    });

    play();
  }

  /* Product page ----------------------------------------------------------- */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = section.querySelector('[data-product-form]');
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare-price]');
    var ribbon = section.querySelector('[data-sale-ribbon]');
    var skuEl = section.querySelector('[data-sku]');

    function showMedia(id) {
      if (!id) return;
      section.querySelectorAll('.gallery__slide').forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.mediaId === String(id));
      });
      section.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.thumb === String(id));
      });
    }

    section.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });

    function selectedOptions() {
      return product.options.map(function (_, i) {
        var checked = form.querySelector('[data-option-input="' + i + '"]:checked');
        return checked ? checked.value : null;
      });
    }

    function markUnavailable(selected) {
      form.querySelectorAll('[data-option-input]').forEach(function (input) {
        var i = parseInt(input.dataset.optionInput, 10);
        var test = selected.slice();
        test[i] = input.value;
        var exists = product.variants.some(function (v) {
          return v.available && v.options.every(function (o, n) { return o === test[n]; });
        });
        var label = form.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !exists);
      });
    }

    function onChange() {
      var selected = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });

      selected.forEach(function (val, i) {
        var label = section.querySelector('[data-option-label="' + i + '"]');
        if (label) label.textContent = val;
      });
      markUnavailable(selected);

      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = theme.strings.unavailable;
        return;
      }

      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;

      priceEl.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEl.hidden = !onSale;
      compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      if (ribbon) ribbon.hidden = !onSale;
      if (skuEl) skuEl.textContent = variant.sku ? theme.strings.sku + ': ' + variant.sku : '';

      if (variant.featured_media) showMedia(variant.featured_media.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) onChange();
    });
    if (product.options.length && !product.variants[0].title.match(/^Default Title$/)) {
      markUnavailable(selectedOptions());
    }
  }

  /* Collection filters & sorting ------------------------------------------ */
  function applyFilters(form, sortValue) {
    var params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
    }
    if (sortValue) params.set('sort_by', sortValue);
    window.location.search = params.toString();
  }

  document.addEventListener('change', function (e) {
    var filtersForm = e.target.closest('[data-filters-form]');
    if (filtersForm) {
      clearTimeout(filtersForm._t);
      filtersForm._t = setTimeout(function () { applyFilters(filtersForm); }, e.target.type === 'number' ? 800 : 0);
      return;
    }
    if (e.target.matches('[data-sort-select]')) {
      var form = document.querySelector('[data-filters-form]');
      if (form) form.querySelector('[name="sort_by"]').value = e.target.value;
      applyFilters(form, e.target.value);
    }
  });

  /* Product recommendations ------------------------------------------------ */
  function initRecommendations(el) {
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* Init ------------------------------------------------------------------- */
  function init() {
    document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    document.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    e.target.querySelectorAll('[data-product-section]').forEach(initProduct);
  });

  theme.formatMoney = formatMoney;
})();
